import styled from 'styled-components';

export const Container = styled.div`
  .MuiPaper-root {
    background: transparent;
  }
  .MuiStepConnector-vertical {
    padding: 0;
    margin-left: 0.7em;
  }
  .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
  }
  .MuiStepLabel-iconContainer {
    padding: 0;
    margin-right: 6px;
  }
`;

